module.exports = __webpack_public_path__ + "img/payments1.578085a3.jpg";